import { Container, Grid } from '@mui/material';
import '../styles/Teams.css';

export default function JokguTeams() {
  return (
    <Container className="jokgu-teams">
      <Grid className="grid-container">
        <table>
          <thead>
            <tr>
              <td>Team</td>
              <td>Team Name</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Women</td>
              <td>Hi Kick</td>
            </tr>
            <tr>
              <td>L3</td>
              <td>Trinity</td>
            </tr>
            <tr>
              <td>L2</td>
              <td>Savage Wolves</td>
            </tr>
            <tr>
              <td>L1</td>
              <td>Lion</td>
            </tr>
            <tr>
              <td>Warehouse</td>
              <td>SOOJOKGU 🥇</td>
            </tr>
            <tr>
              <td>Managers</td>
              <td>Lovelyz 🥈</td>
            </tr>
            <tr>
              <td>QA/QC</td>
              <td>Control</td>
            </tr>
            <tr>
              <td>Fabshop A</td>
              <td>M.F A 🥉</td>
            </tr>
            <tr>
              <td>Fabshop B</td>
              <td>M.F B 🥉</td>
            </tr>
            <tr>
              <td>Office</td>
              <td>UBC</td>
            </tr>
            <tr>
              <td>RnD</td>
              <td>Labsters</td>
            </tr>
            <tr>
              <td>Woodshop</td>
              <td>Tigerwoods</td>
            </tr>
            <tr>
              <td>Accounting</td>
              <td>ABC</td>
            </tr>
            <tr>
              <td>Sales</td>
              <td>Hunters</td>
            </tr>
          </tbody>
        </table>
      </Grid>
    </Container>
  );
}
